var map = {
	"./dept-1.svg": "6606",
	"./dept-10.svg": "626e",
	"./dept-11.svg": "2ea6",
	"./dept-12.svg": "5637",
	"./dept-2.svg": "f7c6",
	"./dept-3.svg": "badf",
	"./dept-4.svg": "44df",
	"./dept-5.svg": "394b",
	"./dept-6.svg": "9937",
	"./dept-7.svg": "4c96",
	"./dept-8.svg": "7295",
	"./dept-9.svg": "acb9",
	"./dept-card-m/dept-1.svg": "2e23",
	"./dept-card-m/dept-10.svg": "db97",
	"./dept-card-m/dept-11.svg": "a19f",
	"./dept-card-m/dept-12.svg": "9f0a",
	"./dept-card-m/dept-2.svg": "7ed1",
	"./dept-card-m/dept-3.svg": "e889",
	"./dept-card-m/dept-4.svg": "547f",
	"./dept-card-m/dept-5.svg": "683d",
	"./dept-card-m/dept-6.svg": "9a24",
	"./dept-card-m/dept-7.svg": "c49e",
	"./dept-card-m/dept-8.svg": "550b",
	"./dept-card-m/dept-9.svg": "640e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0e0";